<!-- version 2021/05/20 -->
<template>
  <div class="body-inner">
    <textarea
      ref="emoji_textarea"
      v-model="textValue"
      :name="name"
      :cols="cols"
      :rows="rows"
      class="body-textarea"
      :placeholder="placeholder"
    />

    <app-label-text
      class="body-counter"
      :title="counter"
    />

    <emoji-picker @emoji="insert">
      <div
        slot="emoji-invoker"
        slot-scope="{ events: { click: clickEvent } }"
        class="emoji"
        @click.stop="clickEvent"
      >
        <div
          id="btn-trigger"
          class="emoji-icon"
        >
          <i
            class="fa fa-smile-o fa-2x active"
            aria-hidden="true"
          />
        </div>
      </div>
      <div
        slot="emoji-picker"
        slot-scope="{ emojis, insert }"
        class="emoji-inner"
      >
        <div
          v-for="(emojiGroup, category) in emojis"
          :key="category"
        >
          <div class="l_emoji_list">
            <span
              v-for="(emoji, emojiName) in emojiGroup"
              :key="emojiName"
              :title="emojiName"
              @click="insert(emoji)"
            >
              {{ emoji }}
            </span>
          </div>
        </div>
      </div>
    </emoji-picker>
  </div>
</template>

<script>
import LabelText from '../text/label-text.vue';
import EmojiPicker from 'vue-emoji-picker';

export default {
  components: {
    appLabelText: LabelText,
    EmojiPicker
  },
  props: {
    name: String,
    text: String,
    cols: Number,
    rows: Number,
    maxChar: Number ,
    placeholder: {
      type: String,
      default: '本文を入力'
    },
  },
  data() {
    return {
      maxCharCount : 1000,
      textValue : this.text
    };
  },
  computed: {
    counter() {
      if (this.textValue.length === 0) {
        return "0/" + this.maxCharCount;
      } else {
        return this.textValue.length + "/" + this.maxCharCount;
      }
    }
  },
  watch: {
    text(value) {
      this.textValue = value;
    }
  },
  created() {
    this.setMaxCharCount();
  },
  methods: {
    setMaxCharCount() {
      if (typeof this.maxChar !== "undefined") {
        this.maxCharCount = this.maxChar;
      }
    },
    insert(emoji) {
      let textarea = this.$refs.emoji_textarea;
      let cursorPosition = textarea.selectionStart;
      let endPosition = textarea.selectionEnd;
      let content = textarea.value;
      this.textValue = content.substring(0, cursorPosition) + emoji + content.substring(endPosition, content.length);
    },
  }
};
</script>

<style lang="sass" scoped>
  .body-inner
    position: relative

  .body-textarea
    width: 100%
    border: 1px solid #e5e5e5
    border-radius: 3px
    background: #f8f8f8
    min-height: 250px
    resize: vertical
    padding: 10px
    &::placeholder
      color: #bcbcbc

  .body-counter
    position: absolute
    bottom: -34px
    right: 5px
    font-weight: 300
    font-size: 16px
    color: #405E66

  .emoji
    position: absolute
    cursor: pointer
    display: block
    width: 25px
    height: 25px
    z-index: 2
    background: white
    opacity: .9
    margin-top: 10px

  .emoji-icon
    cursor: pointer

  .emoji-inner
    cursor: pointer
    height: 220px
    overflow-y: scroll
    border: 1px solid #29c3cd
    border-radius: 6px
    padding: 10px
    margin-top: 18px
    position: absolute
    max-width: 570px
    top: 155px
    width: 100%
    right: -8px
    background: rgba(255, 255, 255, 0.83)
    z-index: 20
    box-shadow: 6px 6px 6px #ddd

  i
    position: absolute
    color: rgba(0, 0, 0, 0.06)
    &.active
      color: #28c3cd
      bottom: 0
  .counter
    position: absolute

</style>
